import './messagingButton.css';
import { VscSend } from "react-icons/vsc";
import { useState, useEffect } from "react";

export default function MessagingButton(props) {
    let [inputText, setInputText] = useState('');
    function textContentChange(event) {
        setInputText(event.target.value);
    }

    function buttonclick() {
        props.setIsloading(true);
        props.clickHandler(inputText);
    }

    function handleTextareaKeyChange(event) {
        if (event.key === "Enter"  && event.shiftKey && !event.altKey) {
            event.preventDefault();
            if (inputText != '') {
                props.setIsloading(true);
            }
            buttonclick();
        }
    }

    return (
        <>
            {/* <button
                className="messagingButton"
                onClick={props.clickHandler}
                disabled={props.disableButton}>
                    Let's Chat
                {props.showSpinner && <span className="messagingButtonLoadingUI loadingBalls"></span>}
            </button> */}
                          <div style={{width: "80%",fontSize:"1rem",lineHeight:"20px", height:"64px", backgroundColor: "white"}} className="messagingFooter inputdiv">

                              <input style={{width: "100%",fontSize:"1rem", height:"60px", padding:"0px" }} className="messagingInputTextarea" 
                                placeholder="SOHOBBのアイモンです、Salesforce導入のKnowHowをお伝え出来ます。"
                                list='suggestions'
                                onKeyDown={handleTextareaKeyChange}
                                onChange={textContentChange}
 />
             <datalist id='suggestions'>
                <option value="Herokuの実績ありますか？" />
                <option value="GMOという決済サービスとの連携構築の実績がありますか？" />
            </datalist>
        
            <button className="sendButton" style={{width:50}}>

                <VscSend className="sendButtonIcon" onClick={buttonclick}/>
            </button>
                        </div>
        </>
    );
}